export default __webpack_public_path__ + "static/media/avatar-4.372ee5b6.jpg";